import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

export interface ProfitPoint {
  date: string;
  revenue?: number;
  net_profit: number;
  forecast?: boolean;
}

/**
 * Profit-over-time line chart. Optionally overlays a projected (dotted) series
 * for the forecast widget. PLAN.md §7.1 / §7.5.
 */
export default function ProfitChart({
  data,
  showRevenue = true,
}: {
  data: ProfitPoint[];
  showRevenue?: boolean;
}) {
  return (
    <ResponsiveContainer width="100%" height={320}>
      <LineChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E1E3E5" />
        <XAxis dataKey="date" tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 12 }} />
        <Tooltip />
        <Legend />
        {showRevenue && (
          <Line
            type="monotone"
            dataKey="revenue"
            name="Revenue"
            stroke="#5C6AC4"
            strokeWidth={2}
            dot={false}
          />
        )}
        <Line
          type="monotone"
          dataKey="net_profit"
          name="Net profit"
          stroke="#008060"
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
